import css from "./styles.module.scss"; 

const STKCheckbox = ( props:any ) => {

    
    return(
        <div className={css.checkboxWrapper}>
            <div className={css.checkbox}> 
                <input ref={props.inputRef} id={`checkbox-${props.id ? props.id : props.label}`} type={props.type} name={props.name} value={props.value} onChange={props.onChange} defaultChecked={props.defaultChecked} /> 
                <label htmlFor={`checkbox-${props.id ? props.id : props.label}`}><span>{props.label}</span></label>
                <div className={css.subFields }>
                    {props.children}
                </div>
            </div>
            <span className={css.checkboxInvalidMessage}>{props.invalid}</span>
        </div>
    );

}

export default STKCheckbox;